import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { usePinGate } from '../../hooks/usePinGate';

interface PinGuardProps {
  children: React.ReactNode;
}

const PinGuard: React.FC<PinGuardProps> = ({ children }) => {
  const location = useLocation();
  const {
    isLoading,
    isPinRequired,
    isPinValidated,
    pinUrl,
    error,
  } = usePinGate();



  if (isLoading) {
    return (
      <div className="min-h-dvh bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <div className="flex items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
            <span className="ml-3 text-gray-600">
              Preparing secure access...
            </span>
          </div>
        </div>
      </div>
    );
  }

  if (error && !isPinRequired) {
    // If an error occurred but the gate is not required, allow access.
    return <>{children}</>;
  }

  if (isPinRequired && !isPinValidated) {
    if (location.pathname === pinUrl) {
      return <>{children}</>;
    }

    return (
      <Navigate
        to={pinUrl}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default PinGuard;
